import React, { Component } from "react";
import {
  Table,
  Button,
  Alert,
  Tag,
  Input,
  List,
  Card,
  Avatar,
  Icon,
  Rate,
  message
} from "antd";
import { Link } from "react-router-dom";
const { Search } = Input;
const queryString = require("query-string");

class GenTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filteredInfo: null,
      searchvalue: "",
      sortedInfo: null,
      filteredBranch: [],
      columns: null,
      columnsData: null,
      dynamicData: null,
      tableData:null,
      filteredInfo: {
        branch: null,
        campus: null,
        section: null
      },
      filteredCampus: [],
      filteredSection: [],
      selectedRowKeys: []
    };
  }

  componentDidMount() {
    var parsed = queryString.parse(this.props.props.location.search);

    this.setState({tableData:this.props.data})

    if (!parsed.Branch || parsed.Branch == "null") {
      parsed.Branch = null || this.props.branch;
    }

    if (parsed.Branch) {
      parsed.Branch = [parsed.Branch];
    }

    if (!parsed.Campus || parsed.Campus == "null") {
      parsed.Campus = null || this.props.campus;
    }

    if (parsed.Campus) {
      parsed.Campus = [parsed.Campus];
    }

    if (!parsed.Section || parsed.Section == "null") {
      parsed.Section = null || this.props.section;
    }

    if (parsed.Section) {
      parsed.Section = [parsed.Section];
    }

    if (parsed.Branch || parsed.Campus || parsed.Section) {
      this.setState({
        filteredBranch: [parsed.Branch],
        filteredCampus: [parsed.Campus],
        filteredSection: [parsed.Section],
        filteredInfo: {
          branch: parsed.Branch,
          campus: parsed.Campus,
          section: parsed.Section
        }
      });
    }
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredBranch: filters.branch || [],
      filteredCampus: filters.campus || [],
      filteredSection: filters.section || [],
      filteredInfo: filters,
      sortedInfo: sorter
    });
  };

  clearAll = () => {
    this.setState({
      filteredBranch: [],
      filteredCampus: [],
      filteredSection: [],
      filteredInfo: null,
      sortedInfo: null
    });
  };

  setAgeSort = () => {
    this.setState({
      sortedInfo: {
        order: "descend",
        columnKey: "age"
      }
    });
  };

  onSelectChange = (selectedRowKeys, selectedRows) => {
    const selected = Array.prototype.map
      .call(selectedRows, function(item) {
        return item.email;
      })
      .join(",");
    this.setState({ selected });
    this.setState({ selectedRowKeys });
  };

  sendMail = () => {
    window.open(
      "mailto:" + this.state.selected,
      "name",
      "height=900,width=900"
    );
  };

  searchTable = (value,dataTable) => {


   const newData= dataTable.filter(data=> Object.keys(data).filter(key => (data[key]&& ((data[key]).toString().toUpperCase()).includes((value).toUpperCase()))).length > 0 ? true: false)
   this.setState({tableData:newData})
   
  };

  render() {
    
    let {
      sortedInfo,
      filteredInfo,
      selectedRowKeys,
      filteredBranch,
      filteredCampus,
      filteredSection,
      columnsData,
      dynamicData,
      tableData
    } = this.state;
    sortedInfo = sortedInfo || {};
    filteredInfo = filteredInfo || {};
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
      onSelect: this.onSelect
    };
    const columns = [
      {
        title: "Name",
        dataIndex: "fullName",
        key: "fullName",
        sorter: (a, b) =>
          a.fullName && a.fullName.localeCompare(b.fullName),
        width: 200,
        render: (text, row, index) => (
          <Link to={`/home/profile/${row.UID}`}>{text}</Link>
        )
      },
      {
        title: "Roll Number",
        dataIndex: "rollnumber",
        key: "rollnumber",
        width: 120,
        render: (text, row, index) => (
          <>
            <Tag color="#2db7f5">{text}</Tag>
          </>
        )
      },
      {
        title: "gradYear",
        dataIndex: "gradYear",
        key: "gradYear",
        filters: [
          { text: "2019", value: "2019" },
          { text: "2020", value: "2020" },
          { text: "2021", value: "2021" },
          { text: "2022", value: "2022" },
          { text: "2023", value: "2023" },
          { text: "2024", value: "2024" },
          { text: "2025", value: "2025" }
        ],
        filteredValue: filteredInfo.gradYear || null,
        onFilter: (value, record) =>
          record &&
          record.gradYear &&
          record.gradYear.match(new RegExp("^" + value + "$", "g")),
        width: 80
      },
      {
        title: "Campus",
        dataIndex: "campus",
        key: "campus",
        width: 100,
        filters: [
          { text: "BVRIT", value: "BVRIT" },
          { text: "VIT", value: "VIT" },
          { text: "BVRITH", value: "BVRITH" },
          { text: "SVECW", value: "SVECW" }
        ],
        filteredValue: filteredInfo.campus || null,
        onFilter: (value, record) =>
          record &&
          record.campus &&
          record.campus.match(new RegExp("^" + value + "$", "g")),
        ellipsis: true
      },
      {
        title: "Branch",
        dataIndex: "branch",
        key: "branch",
        width: 100,
        filters: [
          { text: "ECE", value: "ECE" },
          { text: "CSE", value: "CSE" },
          { text: "IT", value: "IT" },
          { text: "EIE", value: "EIE" },
          { text: "EEE", value: "EEE" },
          { text: "MECH", value: "MECH" }
        ],
        filteredValue: filteredInfo.branch || null,
        onFilter: (value, record) =>
          record &&
          record.branch &&
          record.branch.match(new RegExp("^" + value + "$", "g")),
        ellipsis: true
      },
      {
        title: "Skills Count",
        dataIndex: "technicalSkillsArray",
        key: "technicalSkillsArrayCount",
        width: 130,
        render: skillLearntAtInternship => (
          <span>
            {skillLearntAtInternship ? skillLearntAtInternship.length : 0}
          </span>
        ),
        defaultSortOrder: "descend",
        sorter: (a, b) =>
          a.technicalSkillsArray && b.technicalSkillsArray
            ? a.technicalSkillsArray.length - b.technicalSkillsArray.length
            : true
      },
      {
        title: "Technical Skills",
        dataIndex: "technicalSkillsArray",
        key: "technicalSkillsArray",
        width: 300,
        render: technicalSkillsArray => (
          <span>
            {technicalSkillsArray && technicalSkillsArray.length > 0
              ? technicalSkillsArray.map(tag => (
                  <Tag style={{ marginBottom: 2 }} color={"blue"} key={tag}>
                    {tag.toUpperCase()}
                  </Tag>
                ))
              : "NA"}
          </span>
        )
      },
      {
        title: "Projects Count",
        dataIndex: "projectsDoneListArray",
        key: "projectsDoneListArray",
        width: 120,
        render: skillLearntAtInternship => (
          <span>
            {skillLearntAtInternship ? skillLearntAtInternship.length : "NA"}
          </span>
        ),
        sortDirections: ["descend", "ascend"],
        sorter: (a, b) =>
          a.projectsDoneListArray &&
          a.projectsDoneListArray.length - b.projectsDoneListArray.length
      },
      {
        title: "Workshops Count",
        dataIndex: "workshopsAttendedArray",
        key: "workshopsAttendedArray",
        width: 150,
        render: skillLearntAtInternship => (
          <span>
            {skillLearntAtInternship ? skillLearntAtInternship.length : "NA"}
          </span>
        ),
        defaultSortOrder: "descend",
        sorter: (a, b) =>
          a.workshopsAttendedArray &&
          a.workshopsAttendedArray.length - b.workshopsAttendedArray.length
      },
      {
        title: "Internships Count",
        dataIndex: "InternshipAttendedArray",
        key: "InternshipAttendedArray",
        width: 150,
        render: skillLearntAtInternship => (
          <span>
            {skillLearntAtInternship ? skillLearntAtInternship.length : "NA"}
          </span>
        ),
        defaultSortOrder: "descend",
        sorter: (a, b) =>
          a.InternshipAttendedArray &&
          a.InternshipAttendedArray.length - b.InternshipAttendedArray.length
      },
      {
        title: "Certification Count",
        dataIndex: "certificationArray",
        key: "certificationArray",
        width: 150,
        render: skillLearntAtInternship => (
          <span>
            {skillLearntAtInternship ? skillLearntAtInternship.length : "NA"}
          </span>
        ),
        defaultSortOrder: "descend",
        sorter: (a, b) =>
          a.certificationArray &&
          a.certificationArray.length - b.certificationArray.length
      },
      {
        title: "Publication Count",
        dataIndex: "pubicationsArray",
        key: "pubicationsArray",
        width: 150,
        render: skillLearntAtInternship => (
          <span>
            {skillLearntAtInternship ? skillLearntAtInternship.length : "NA"}
          </span>
        ),
        defaultSortOrder: "descend",
        sorter: (a, b) =>
          a.pubicationsArray &&
          a.pubicationsArray.length - b.pubicationsArray.length
      },
      {
        title: "Conferences Count",
        dataIndex: "conferenceAttendedArray",
        key: "conferenceAttendedArray",
        width: 150,
        render: skillLearntAtInternship => (
          <span>
            {skillLearntAtInternship ? skillLearntAtInternship.length : "NA"}
          </span>
        ),
        defaultSortOrder: "descend",
        sorter: (a, b) =>
          a.conferenceAttendedArray &&
          a.conferenceAttendedArray.length - b.conferenceAttendedArray.length
      },
      {
        title: "Overall Score",
        dataIndex: "score",
        key: "score",
        width: 100,
        fixed: "right",
        render: (text, row, index) => {
          const {
            InternshipAttendedArray,
            conferenceAttendedArray,
            pubicationsArray,
            certificationArray,
            workshopsAttendedArray,
            projectsDoneListArray,
            technicalSkillsArray
          } = row;
          {
            return (
              InternshipAttendedArray.length +
              conferenceAttendedArray.length +
              pubicationsArray.length +
              certificationArray.length +
              workshopsAttendedArray.length +
              projectsDoneListArray.length +
              technicalSkillsArray.length
            );
          }
        }
      }
    ];

    const hasSelected = selectedRowKeys.length > 0;
    return (

      <div>
        <div style={{ marginBottom: 16 }}>
          <Button
            onClick={this.sendMail}
            type="primary"
            disabled={!hasSelected}
          >
            Send Mail
          </Button>
          <span style={{ marginLeft: 8 }}>
            {hasSelected ? `Selected ${selectedRowKeys.length} items` : ""}
          </span>
        </div>

        {filteredBranch.length > 0 ||
        filteredCampus.length > 0 ||
        filteredSection.length > 0 ? (
          <>
            <Alert
              message={`Filtered by ${filteredCampus.toString()} Campus | ${filteredBranch.toString()} Branch | ${filteredSection.toString()} Section`}
              type="info"
              showIcon
            />{" "}
            <Button
              type="primary"
              icon="close"
              onClick={this.clearAll}
              style={{ marginBottom: 25, marginTop: 10 }}
            >
              Clear Filters
            </Button>{" "}
          </>
        ) : null}

        {columns && this.props.data && tableData ? (
          <Table
            title={() => (
              <>
                <Search
                  placeholder="Search in table"
                  enterButton="Search"
                  size="large"
                  style={{ width: "85%", marginRight: 10 }}
                  allowClear
                  onSearch={value => this.searchTable(value,this.props.data)}
                  // onSearch={value => this.setState({ searchvalue: value })}
                />
                <Button
                  style={{ background: "#001529", color: "white" }}
                  onClick={() =>
                    message.info("Feature not yet available. Coming soon")
                  }
                  type="dashed"
                  icon="download"
                  size="large"
                >
                  Export to Excel
                </Button>
              </>
            )}
            scroll={{ x: true }}
            bordered
            rowSelection={rowSelection}
            rowKey={this.props.data.UID}
            columns={columns}
            dataSource={tableData}
            onChange={this.handleChange}
          />
        ) : null}
      </div>
    );
  }
}

export default GenTable;
